import { Component, OnInit } from '@angular/core';
import { TreatmentPlanMeta, TreatmentPlanMetaService } from 'src/app/service/treatment-plan-meta.service';
import { ActivatedRoute } from '@angular/router';
import { PlanDeTraitementService } from 'src/app/service/planDeTraitement.service';
export type CommandeStatus =
  | 'EN_COURS'
  | 'ENVOYER_LABO'
  | 'VALIDER_STARTUP'
  | 'PRISE_EN_CHARGE_LABO'
  | 'ENVOYER_CABINET'
  | 'RECU_CABINET'
  | 'POSE'
  | 'ANNULER';

@Component({
  selector: 'app-suivis-pdt',
  templateUrl: './suivis-pdt.component.html',
  styleUrls: ['./suivis-pdt.component.scss'],
})
export class SuivisPdtComponent implements OnInit {

  constructor(
    private treatmentMetaService: TreatmentPlanMetaService,
    private route: ActivatedRoute,
    private planDeTraitementService: PlanDeTraitementService
  ) { }
  isLoading: boolean = false;
  praticien: any;
  ngOnInit() {
    let value = localStorage.getItem("currentUser");
    this.praticien = JSON.parse(value);

    // Check if we have a highlightId in query params
    const highlightId = this.route.snapshot.queryParams['highlightId'];
    if (highlightId) {
      console.log('Notification flow: Loading only specific plan', highlightId);
      this.highlightAndSyncPlan(+highlightId);
    } else {
      this.loadPlansByLabo(this.praticien.id);
    }
    this.checkAndHighlight(); // Start listening for future changes once
  }

  // Public method to be called from parent
  public loadAllPlans() {
    if (this.praticien && this.praticien.id) {
      this.loadPlansByLabo(this.praticien.id);
    }
  }

  // getStatusClass(status: CommandeStatus): string {
  //   switch (status) {
  //     case 'RECU': return 'status-recu';
  //     case 'ANNULER': return 'status-annuler';
  //     case 'EN_COURS': return 'status-traitement';
  //     case 'EXPEDIER': return 'status-expedier';
  //     default: return 'status-default';
  //   }
  // }

  allPlans: any = [];       // tous les plans (chargés en arrière-plan)
  plansPose  : any = []; 
  plansSansPose : any = []; 
  patientsMapped: any[] = [];   // tableau final affiché
  patients: any[] = [];
  filteredPatients: any[] = [];
  isFullListLoaded: boolean = false;
  loadPlansByLabo(laboId: number) {
    this.isLoading = true;
    this.isFullListLoaded = true;

    this.treatmentMetaService.getListPlanDeTraitementByDoctor(laboId).subscribe({
      next: (data) => {
        console.log('Plans récupérés par labo :', data);

        this.allPlans = data;
        this.plansPose = this.allPlans
        .filter(plan => plan.status == 'POSE')
        .sort((a, b) =>
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      // this.plansSansPose = this.allPlans.filter(plan => plan.status != 'POSE');
      this.plansSansPose = this.allPlans
        .filter(plan => plan.status !== 'POSE')
        .sort((a, b) =>
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        //  Transformer les données backend → format UI
        console.log("plansPose", this.plansPose);
        console.log("plansSansPose :", this.plansSansPose);
        this.patientsMapped = this.plansSansPose;;
        console.log('patientsMapped :', this.patientsMapped);

        this.patients = this.plansSansPose;
        console.log('patients :', this.patients);

        // 🔁 garder filteredPatients synchro
        this.filteredPatients = [...this.patientsMapped];

        this.applyFilters();

        this.isLoading = false;
      },
      error: (err) => {
        console.error('Erreur lors du chargement par labo :', err);
        this.isLoading = false;
      }
    });
  }
  planTypeOptions: string[] = [
    'ALL',
    'ALIGNEUR',
    'RCC',
    'BIBAGUE',
    'PDT',
    'CR',
  ];
  searchTerm: string = '';
  filters = {
    statusCommande: 'Reçu Cabinet',
    typePlan: 'ALL'
  };
commandeStatusOptions: string[] = [
  'ALL',
  'Reçu Startup',
  // 'Valider Startup',
  'Validé & Envoyé Labo',
  'Pris en charge Labo',
  'Envoyé Cabinet',
  'Reçu Cabinet',
  // 'Posé',
  // 'Annulé'
];
  onFilterPlanTypeChange(value: string) {
    console.log('value', value);

    this.filters.typePlan = value;
    this.applyFilters();
  }

  onFilterStatusChange(value: string) {
    console.log('value', value);

    this.filters.statusCommande = value;
    this.applyFilters();
  }


  onSearch() {
    console.log('onSearch', this.searchTerm);

    this.currentPage = 1;
    this.applyFilters();
  }
  // Backend → UI
backendToLabel(status: CommandeStatus): string {
  switch (status) {
    case 'EN_COURS': return 'Reçu Startup';
    // case 'VALIDER_STARTUP': return 'Valider Startup';
    case 'ENVOYER_LABO': return 'Validé & Envoyé Labo';
    case 'PRISE_EN_CHARGE_LABO': return 'Pris en charge Labo';
    case 'ENVOYER_CABINET': return 'Envoyé Cabinet';
    case 'RECU_CABINET': return 'Reçu Cabinet';
    // case 'POSE': return 'Posé';
    case 'ANNULER': return 'Annulé';
    default: return status;
  }
}


  // UI → Backend
labelToBackend(label: string): CommandeStatus | 'ALL' {
  switch (label) {
    case 'Reçu Startup': return 'EN_COURS';
    // case 'Valider Startup': return 'VALIDER_STARTUP';
    // case 'VALIDER_STARTUP': return 'Valider Startup';

    case 'Validé & Envoyé Labo': return 'ENVOYER_LABO';
    case 'Pris en charge Labo': return 'PRISE_EN_CHARGE_LABO';
    case 'Envoyé Cabinet': return 'ENVOYER_CABINET';
    case 'Reçu Cabinet': return 'RECU_CABINET';
    // case 'Posé': return 'POSE';
    case 'Annulé': return 'ANNULER';
    default: return 'ALL';
  }
}
  applyFilters() {
    const search = this.searchTerm
      ? this.searchTerm.toLowerCase()
      : '';
    this.patientsMapped = this.patients.filter(p => {
      const matchStatus =
        this.filters.statusCommande === 'ALL' ||
        this.backendToLabel(p.status) === this.filters.statusCommande;

      const matchType =
        this.filters.typePlan === 'ALL' ||
        p.typePDT === this.filters.typePlan;
      const matchSearch =
        !search ||
        (p.patientName && p.patientName.toLowerCase().includes(search));

      return matchStatus && matchType && matchSearch;
    });

    this.updatePaginatedPatients();
  }




  currentPage: number = 1;
  itemsPerPage: number = 50;
  totalItems: number = 0;
  paginatedPatients: any[] = [];
  totalPages = 1;
  startItem = 0;
  endItem = 0;
  updatePaginatedPatients() {

    this.totalItems = this.patientsMapped.length;
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);

    if (this.currentPage > this.totalPages && this.totalPages > 0) {
      this.currentPage = this.totalPages;
    }

    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;

    this.paginatedPatients = this.patientsMapped.slice(start, end);
    console.log('this.paginatedPatients', this.paginatedPatients);

    this.startItem = this.totalItems === 0 ? 0 : start + 1;
    this.endItem = Math.min(end, this.totalItems);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedPatients();
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
    this.updatePaginatedPatients();
  }


  onItemsPerPageChange() {
    this.currentPage = 1;
    this.updatePaginatedPatients();
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedPatients();
    }
  }



  getTypeBadgeClass(type: string): string {
    if (!type) return 'badge-default';

    switch (type) {

      case 'ALIGNEUR':
        return 'badge-blue';

      case 'BIBAGUE':
        return 'badge-green';

      case 'RCC':
        return 'badge-orange';

      case 'PDT':
        return 'badge-purple';

      case 'CR':
        return 'badge-red';

      default:
        return 'badge-default';
    }
  }



  private checkAndHighlight() {
    this.route.queryParams.subscribe(params => {
      const highlightId = params['highlightId'];
      if (highlightId) {
        this.highlightAndSyncPlan(+highlightId);
      }
    });
  }

  private highlightAndSyncPlan(id: number) {
    // Sync data first using the new enriched API
    console.log('Highlighting plan with enriched data:', id);
    const doctorId = this.praticien ? this.praticien.id : null;

    this.treatmentMetaService.getByDoctorAndId(doctorId, id).subscribe({
      next: (response: any[]) => {
        const freshPlan = response && response.length > 0 ? response[0] : null;
        if (freshPlan) {
          console.log('Target plan loaded:', freshPlan);

          // Logic to prevent "printed plus previous one"
          if (!this.isFullListLoaded) {
            // Targeted mode: always show ONLY the clicked plan
            this.patients = [freshPlan];
            this.patientsMapped = [freshPlan];
          } else {
            // Full list mode: update existing entry or append
            const mainIndex = this.patients.findIndex(p => p.id === id);
            if (mainIndex !== -1) {
              this.patients[mainIndex] = { ...this.patients[mainIndex], ...freshPlan };
            } else {
              this.patients.unshift(freshPlan);
            }
          }

          // Force update display
          this.applyFilters();

          // Check if it's in the filtered list
          let index = this.patientsMapped.findIndex(p => p.id === id);

          if (index === -1) {
            // Not found in filtered results? Clear filters to ensure it's visible
            console.log('Plan not visible with current filters, clearing filters...');
            this.searchTerm = '';
            this.filters.statusCommande = 'ALL';
            this.filters.typePlan = 'ALL';
            this.applyFilters();
            index = this.patientsMapped.findIndex(p => p.id === id);
          }

          if (index !== -1) {
            // Determine page and navigate to it
            const page = Math.ceil((index + 1) / this.itemsPerPage);
            if (this.currentPage !== page) {
              this.goToPage(page);
            }

            // Scroll and highlight
            setTimeout(() => {
              const row = document.querySelector(`tr[data-plan-id="${id}"]`);
              if (row) {
                row.scrollIntoView({ behavior: 'smooth', block: 'center' });
                row.classList.add('highlight-blue-shadow');
                setTimeout(() => {
                  row.classList.remove('highlight-blue-shadow');
                }, 3000);
              } else {
                console.warn('Row not found for highlighting', id);
              }
            }, 500);
          } else {
            console.warn('Plan still not found in list after clearing filters', id);
          }
        } else {
          console.warn('No enriched plan data found for ID:', id);
        }
      },
      error: (err) => console.error('Error syncing plan for highlight', err)
    });
  }

  poser(plan: any) {
     const now = new Date();
  plan.poseLe = now.toISOString().slice(0, 19).replace('T', ' ');
  console.log('Pose cliquée pour', plan);
  plan.status = 'POSE';
  this.updatePlan(plan);
  // ici ton traitement (API, popup, update, etc.)
}

  updatePlan(plan: any) {
    console.log("plan", plan);

    this.treatmentMetaService.update(plan.id, plan).subscribe(resp => {
      console.log("Mise à jour réussie :", resp);

      // 1 Trouver l'index du plan dans allPlans
      const index = this.allPlans.findIndex(p => p.id === plan.id);

      if (index !== -1) {
        // 2 Mettre à jour la version locale
        this.allPlans[index] = { ...this.allPlans[index], ...plan };
      }

      // 3 Mise à jour des listes utilisées par le front
      this.patients = this.allPlans.slice();

          const indexPage = this.paginatedPatients.findIndex(p => p.id === plan.id);
    if (indexPage !== -1) {
      this.paginatedPatients[indexPage] = {
        ...this.paginatedPatients[indexPage],
        ...plan
      };
    }

    // 3️⃣ (optionnel) update patientsMapped si tu veux rester cohérent
    const indexMapped = this.patientsMapped.findIndex(p => p.id === plan.id);
    if (indexMapped !== -1) {
      this.patientsMapped[indexMapped] = {
        ...this.patientsMapped[indexMapped],
        ...plan
      };
    }
    this.close();
      // this.applyFilters();

    });
  }
showFacture : boolean = false ;
selectedInvoice = null ;
selectedPatient:any = null;

  createInvoice(patient){
    console.log('idFacture',patient.idInvoice);
    this.selectedInvoice = patient.idInvoice ;
    this.selectedPatient = patient.idPatient ;
    if (patient.idInvoice){
    this.showFacture = true ;
    }
  }

    closePdtsModal(){ 
    this.showFacture = false;
    this.selectedInvoice = null;
    this.selectedPatient = null;
    this.selectedPdt = null ;
    this.showPdtDetailsPopup = false ;
  }


  showArchivePose = false;
toggleArchivePose() {
  this.showArchivePose = !this.showArchivePose;

  if (this.showArchivePose) {
    this.patientsMapped = this.plansPose;
    this.patients = this.plansPose;
  } else {
    this.patientsMapped = this.plansSansPose;
    this.patients = this.plansSansPose;
  }
console.log('patientsMapped',this.patientsMapped);
console.log('patients',this.patients);

this.onFilterStatusChange('ALL')
  this.currentPage = 1; // reset pagination
}

sortDirection: 'asc' | 'desc' = 'desc';

sortByDays() {

  // inverser le sens
  this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';

  this.patients.sort((a, b) => {
    const dateA = new Date(a.date).getTime();
    const dateB = new Date(b.date).getTime();

    return this.sortDirection === 'asc'
      ? dateA - dateB   // ancien → récent
      : dateB - dateA;  // récent → ancien
  });
  this.applyFilters();
}

getDaysDifference(date1: string, date2?: string): number {
  // Convert "YYYY-MM-DD HH:mm:ss" → Date
  const parseDate = (dateStr: string): Date => {
    return new Date(dateStr.replace(' ', 'T'));
  };

  const d1 = parseDate(date1);
  const d2 = date2 ? parseDate(date2) : new Date();

  // Normaliser à minuit pour éviter les bugs d’heures
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);

  const diffTime = d2.getTime() - d1.getTime();
  const diffDays = diffTime / (1000 * 60 * 60 * 24);

  return Math.abs(Math.round(diffDays));
}
showPdtDetailsPopup : boolean= false;
selectedPdt = null ;

showPdtDetails(pdt : any){
  this.selectedPdt = pdt ;
  this.showPdtDetailsPopup = true ;
}

fichePatientRedirect(id:any){
    if (id != undefined) {
      localStorage.setItem('idPatient', id.toString());
      window.location.href = '/fiche-patient';
      
    }
}
showserviceClinquePopup:boolean = false;
showDetailClinque(item :any){
  this.showserviceClinquePopup = true ;
  this.selectedPdt = item;
}


close(){
// this.showpdtPopup = false ;
this.showserviceClinquePopup = false
this.selectedPdt = null;
// this.traitementId = null ;
// this.traitementAligneur = null,
// this.showFormAligneur = false;
// this.showFormRcc = false;
// this.showFormBibague = false;
// this.traitementRccId = null;
// this.traitementBibagueId = null;
// this.traitementRcc = null;
// this.traitementBibague = null;
 this.showCommentModal = false;
 this.editingPatient = null;
 this.editingComment = "";
}
  showCommentModal = false;
  editingComment: string = "";
  editingPatient: any = null;
  addComment(patient: any) {
    this.editingPatient = patient;
    this.editingComment = patient.commentaireDocteur || "";
    this.showCommentModal = true;
  }
  saveComment() {
    if (!this.editingPatient) return;
    const updatedPlan = {
    ... this.editingPatient,
    commentaireDocteur : this.editingComment
    };
  this.updatePlan(updatedPlan);
  }


  showCommentPopupValue= false;
  canWrite= false;
  commentList : any= [];
  selectedCommentIdPdt = null;
  selectedCommentPdt= null;
  pdtCommentType= null;

closePdtsCommentsModal(){
  this.commentList= [];
  this.canWrite= false;
  this.showCommentPopupValue= false;      
}
  
showCommentPopup(value,type,pdt){
  this.editingPatient = pdt
  this.commentList= [];
  this.canWrite= value;
  this.selectedCommentIdPdt = pdt.id;
  this.pdtCommentType = type
  this.commentList = this.filterCommentsByType(pdt.commentaires, type);
  console.log("this.commentList",this.commentList);
  this.showCommentPopupValue= true;
  
}

onCommentsChanged(event: any) {

  const pdt = this.allPlans.find(
    x => x.id === event.idPDT
  );

  if (!pdt) {
    return;
  }

  pdt.commentaires = [
    ...(pdt.commentaires || []).filter(
      c => c.type !== event.type
    ),
    ...event.comments
  ];
}

getLatestCommentByType(comments: any[] = [], type: number) {

  let latest: any | null = null;

  for (const c of comments) {
    if (c.type !== type) continue;

    if (
      !latest ||
      new Date(c.createdAt).getTime() >
      new Date(latest.createdAt).getTime()
    ) {
      latest = c;
    }
  }

  return latest;
}

filterCommentsByType(
  comments: any[] = [],
  type: number
) {
  console.log("comments",comments);
  
  return comments.filter(c => c.type === type);
}

canActivateStep(current: string | null, previous: string | null): boolean {
  return !current && !!previous;
}

updateStep(patient: any, field: string) {
  const now = new Date().toISOString().slice(0, 19).replace('T', ' ');

  let newStatus: string | null = null;

  switch (field) {
  
    case 'envoyerLabo':
      newStatus = 'ENVOYER_LABO';
      break;

    case 'priseEnChargeLabo':
      newStatus = 'PRISE_EN_CHARGE_LABO';
      break;

    case 'envoyerCabinet':
      newStatus = 'ENVOYER_CABINET';
      break;

    case 'recuCabinet':
      newStatus = 'RECU_CABINET';
      break;

    case 'poseLe':
      newStatus = 'POSE';
      break;
  }

  const updatedPlan = {
    ...patient,
    [field]: now,
    ...(newStatus ? { status: newStatus } : {})
  };

  this.updatePlan(updatedPlan);
}

}